import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-cup-line',
      title: 'マグカップ印刷',
      description: 'オリジナルマグカップの制作。記念品やノベルティとして人気です。',
      image: 'https://public.readdy.ai/ai/img_res/d263e62b71a49fcac185c457d1f232bc.jpg',
    },
    {
      icon: 'ri-flask-line',
      title: 'レーザー印刷',
      description: 'ステンレスボトル、金属製品への高精度な印刷。高級感のある仕上がりが魅力です。',
      image: 'https://readdy.ai/api/search-image?query=Premium%20stainless%20steel%20bottles%20and%20metal%20products%20with%20precise%20laser%20engraved%20designs%20displayed%20elegantly%20on%20a%20clean%20white%20surface%20with%20professional%20studio%20lighting%20and%20a%20minimalist%20plain%20background%20highlighting%20the%20sophisticated%20finish&width=600&height=600&seq=service004&orientation=squarish',
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'シルク印刷',
      description: 'Tシャツ、トートバッグなど布製品への印刷。鮮やかな発色と耐久性が特徴です。',
      image: 'https://readdy.ai/api/search-image?query=Colorful%20silk%20screen%20printed%20t-shirts%20and%20tote%20bags%20with%20vibrant%20designs%20displayed%20on%20a%20clean%20white%20surface%20with%20professional%20studio%20lighting%20and%20a%20minimalist%20plain%20background%20showing%20excellent%20color%20saturation%20and%20print%20quality&width=600&height=600&seq=service002&orientation=squarish',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-8 lg:px-16">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-bold rounded-full mb-4">
            SERVICES
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
            多彩な印刷技術で、<br className="md:hidden" />
            あらゆるご要望にお応えします
          </h2>
          <p className="text-lg md:text-xl text-gray-600">
            紙印刷からシルク印刷、レーザー印刷まで
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden rounded-t-3xl">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 w-12 h-12 bg-primary rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white rounded-full font-bold text-base md:text-lg hover:bg-primary-dark transition-all duration-300 whitespace-nowrap"
          >
            サービス詳細を見る
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
